// import * as React from "react";
// import Stack from "@mui/material/Stack";

// import Dialog from "@mui/material/Dialog";
// import AppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import Typography from "@mui/material/Typography";
// import CloseIcon from "@mui/icons-material/Close";
// import Slide from "@mui/material/Slide";
// import { Box, Button, TextField, Grid } from "@mui/material";
// import { UploadFile } from "@mui/icons-material";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// export default function AddDriver() {
//   const [open, setOpen] = React.useState(false);

//   const handleClose = () => {
//     setOpen(false);
//   };
//   const handleFileButtonClick = () => {
//     // Trigger click event on the file input element
//     document.getElementById("fileInput").click();
//   };

//   return (
//     <div>
//       <React.Fragment>
//         <Stack direction="row" spacing={2}>
//           {/* <Button variant="contained" onClick={handleClickOpen} sx={{ backgroundColor: 'blue', '&:hover': { backgroundColor: 'orange' }, textAlign: 'center', marginLeft: '10px' }}><AddIcon />Add Driver</Button> */}
//           <input type="file" id="fileInput" style={{ display: "none" }} />
//           <Button
//             variant="contained"
//             onClick={handleFileButtonClick}
//             sx={{
//               backgroundColor: "blue",
//               "&:hover": { backgroundColor: "orange" },
//               textAlign: "center",
//               marginLeft: "10px",
//             }}
//           >
//             <UploadFile />
//             Import
//           </Button>
//           {/* <Button variant="contained" disabled>
//         Disabled
//       </Button>
//       <Button variant="contained" href="#contained-buttons">
//         Link
//       </Button> */}
//         </Stack>
//         <Dialog
//           fullScreen
//           open={true}
//           onClose={handleClose}
//           TransitionComponent={Transition}
//           PaperProps={{
//             style: {
//               backgroundColor: "white",
//             },
//           }}
//         >
//           <AppBar sx={{ position: "relative" }}>
//             <Toolbar>
//               <IconButton
//                 edge="start"
//                 color="inherit"
//                 onClick={handleClose}
//                 aria-label="close"
//               >
//                 <CloseIcon />
//               </IconButton>
//               <Typography sx={{ ml: 2, flex: 1 }} component="div">
//                 Add New Driver
//               </Typography>
//             </Toolbar>
//           </AppBar>
//           <Box>
//             <Grid
//               container
//               spacing={2}
//               style={{ color: "black", margin: "10px" }}
//             >
//               <Grid item xs={4} sm={1}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Employee ID
//                 </Typography>

//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="Enter ID"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.ID-1"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>

//               <Grid item xs={4} sm={3}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Name
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="Enter name"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.Name"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={4} sm={3}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Personal Email
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="enter email"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="eg@example.com"
//                       type="email"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>

//             <Grid
//               container
//               spacing={2}
//               style={{ color: "black", margin: "10px" }}
//             >
//               <Grid item xs={8} sm={2}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Password
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="Enter password"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.+91 12345689"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={8} sm={2}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Department
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="Enter Department"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g. HR"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "gray",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "gray",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={8} sm={2}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Designation
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="Enter Designation"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g. HR"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "gray",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "gray",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>

//             <Grid
//               container
//               spacing={2}
//               style={{ color: "black", margin: "10px" }}
//             >
//               <Grid item xs={8} sm={3}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Mobile No
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="enter Mobile No"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.+91 12345689"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={8} sm={2.5}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Country
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="enter Mobile No"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.India"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={8} sm={2.5}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Language
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="enter Mobile No"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.+91 12345689"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={8} sm={3}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   User Role
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="enter Mobile No"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.+91 12345689"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>

//               <Grid item xs={10} sm={10}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Address
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="Enter Address"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="e.g.No:2468,Street, Nagar, City"
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//               <Grid item xs={10} sm={10}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   About
//                 </Typography>
//                 <Grid container spacing={2} alignItems="center">
//                   <Grid item xs={12}>
//                     <br></br>
//                     <TextField
//                       label="About"
//                       variant="outlined"
//                       fullWidth
//                       placeholder="Type here..."
//                       inputProps={{ style: { color: "black" } }}
//                       InputLabelProps={{ style: { color: "black" } }}
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           borderColor: "black",
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                         "& .MuiOutlinedInput-input": {
//                           "&::placeholder": { color: "gray" },
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>

//             <Button
//               variant="contained"
//               autoFocus
//               color="inherit"
//               onClick={handleClose}
//               sx={{
//                 backgroundColor: "blue",
//                 "&:hover": { backgroundColor: "orange" },
//                 textAlign: "center",
//                 margin: "25px",
//               }}
//             >
//               Save
//             </Button>
//           </Box>
//         </Dialog>
//       </React.Fragment>
//     </div>
//   );
// }

import React, { useState } from "react";
import {
  Button,
  TextField,
  Modal,
  Box,
  Typography,
  Slide,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { AddPhotoAlternate, DeleteOutline } from "@mui/icons-material";
import { DriverApis } from "../../../Data/axios";

export default function AddDriver({ open, handleClose, onDriverAdded }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [address, setAddress] = useState("");
  const [selectedRadio, setSelectedRadio] = useState("male");
  const [profileImage, setProfileImage] = useState(null);
  const [aadharFront, setAadharFront] = useState(null);
  const [aadharBack, setAadharBack] = useState(null);
  const [licenseFront, setLicenseFront] = useState(null);
  const [licenseBack, setLicenseBack] = useState(null);
  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];
  const handleFormReset = () => {
    setName("");
    setEmail("");
    setMobile("");
    setState("");
    setPinCode("");
    setAddress("");
    setSelectedRadio("male");
    setProfileImage(null);
    setAadharFront(null);
    setAadharBack(null);
    setLicenseFront(null);
    setLicenseBack(null);
  };

  const handleCloseModal = () => {
    handleFormReset();
    handleClose();
  };

  const handleFileChange = (event, setter) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setter(file);
    }
  };

  const handleFileRemove = (setter) => {
    setter(null);
  };

  const handleSaveDriver = async () => {
    try {
      if (!name || !email || !mobile || !state || !pinCode || !address) {
        alert("Please fill in all required fields");
        return;
      }

      let genderValue;
      if (selectedRadio === "male") {
        genderValue = 1;
      } else if (selectedRadio === "female") {
        genderValue = 2;
      } else {
        genderValue = 3; // Others
      }
      const userDataNew = localStorage.getItem("user-info");
      let creator = "";
      if (userDataNew) {
        const parsedData = JSON.parse(userDataNew);
        creator = parsedData.value.empid;
      }
      const formData = new FormData();
      formData.append("username", name);
      formData.append("email", email);
      formData.append("phone", mobile);
      formData.append("role", "1"); // Driver role
      formData.append("address", address);
      formData.append("state", state);
      formData.append("pincode", pinCode);
      formData.append("ref", creator);
      formData.append("gender", genderValue);

      if (profileImage) {
        formData.append("image", profileImage);
      }

      if (aadharFront) {
        formData.append("aadhar_front", aadharFront);
      }

      if (aadharBack) {
        formData.append("aadhar_back", aadharBack);
      }

      if (licenseFront) {
        formData.append("license_front", licenseFront);
      }

      if (licenseBack) {
        formData.append("license_back", licenseBack);
      }

      console.log("Submitting form data:");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`${key}: File - ${value.name} (${value.size} bytes)`);
        } else {
          console.log(`${key}: ${value}`);
        }
      }

      const response = await DriverApis.add(formData);
      if (response && response.success) {
        alert("Driver added successfully!");
        if (onDriverAdded) onDriverAdded();
        handleCloseModal();
      } else {
        const errorMessage =
          response?.message || "Failed to add driver. Please try again.";
        console.error("API Error:", response);
        alert(errorMessage);
      }
    } catch (error) {
      console.error("Error adding driver:", error);
      let errorMessage = "An error occurred while adding the driver.";
      if (error.response) {
        console.error("Error response:", error.response.data);
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        console.error("Error request:", error.request);
        errorMessage =
          "No response received from server. Please check your connection.";
      }

      alert(errorMessage);
    }
  };
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiInputBase-input": {
        color: "#424242",
      },
    },
  };
  const selectProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242",
        py: 1.1, // Adjust padding to match TextField
      },
      "&:hover": {
        backgroundColor: "#f9f9f9",
      },
      minHeight: "40px",
    },
  };
  const FileInput = ({ title, file, onFileChange, onFileRemove, accept }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
        {title}
      </Typography>
      <Box
        sx={{
          border: "1px dashed #bdbdbd",
          borderRadius: 1,
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          position: "relative",
        }}
      >
        {file ? (
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  maxWidth: "70%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {file.name}
              </Typography>
              <IconButton
                onClick={() => onFileRemove()}
                size="small"
                color="error"
              >
                <DeleteOutline />
              </IconButton>
            </Box>
            {file.type.startsWith("image/") && (
              <Box
                sx={{
                  width: "100%",
                  height: 100,
                  backgroundImage: `url(${URL.createObjectURL(file)})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
          </Box>
        ) : (
          <>
            <input
              type="file"
              id={`file-input-${title.replace(/\s+/g, "-").toLowerCase()}`}
              style={{ display: "none" }}
              onChange={(e) => onFileChange(e)}
              accept={accept || "image/*"}
            />
            <label
              htmlFor={`file-input-${title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <Button
                variant="text"
                component="span"
                startIcon={<AddPhotoAlternate />}
                sx={{ color: "#1d82f5" }}
              >
                Upload File
              </Button>
            </label>
            <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
              Click to upload or drag and drop
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );

  return (
    <Modal open={open} onClose={handleCloseModal} closeAfterTransition>
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "85%",
            height: "100%",
            bgcolor: "#f5f5f5",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h3" component="h2" sx={{ color: "#212121" }}>
              Add New Driver
            </Typography>
            <Button
              onClick={handleCloseModal}
              variant="outlined"
              sx={{
                borderColor: "#bdbdbd",
                color: "#424242",
                "&:hover": {
                  borderColor: "#9e9e9e",
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Close
            </Button>
          </Box>
          <Card
            sx={{
              p: 2,
              bgcolor: "#ffffff",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
            }}
          >
            <CardContent>
              <Box sx={{ mb: 4 }}>
                <Grid container spacing={3}>
                  {/* Personal Information */}
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 2 }}>
                      Personal Information
                    </Typography>
                  </Grid>

                  {/* Profile Image */}
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Profile Image"
                      file={profileImage}
                      onFileChange={(e) => handleFileChange(e, setProfileImage)}
                      onFileRemove={() => handleFileRemove(setProfileImage)}
                      accept="image/*"
                    />
                  </Grid>

                  {/* Name */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter name"
                      size="small"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Email <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="example@email.com"
                      size="small"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Phone <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="+91 1234567890"
                      size="small"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Gender */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Gender <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        row
                        value={selectedRadio}
                        onChange={(e) => setSelectedRadio(e.target.value)}
                      >
                        <FormControlLabel
                          value="male"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Male"
                          sx={{ color: "#424242" }}
                        />
                        <FormControlLabel
                          value="female"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Female"
                          sx={{ color: "#424242" }}
                        />
                        <FormControlLabel
                          value="others"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Others"
                          sx={{ color: "#424242" }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {/* State */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      State <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select state
                              </em>
                            );
                          }
                          return selected;
                        }}
                        inputProps={{ "aria-label": "Select state" }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 250,
                            },
                          },
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select state</em>
                        </MenuItem>
                        {indianStates.map((stateName) => (
                          <MenuItem
                            key={stateName}
                            value={stateName}
                            sx={{ fontFamily: "Ubuntu, sans-serif" }}
                          >
                            {stateName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Pin Code */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Pin Code <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter pin code"
                      size="small"
                      value={pinCode}
                      onChange={(e) => setPinCode(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Address */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Address <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter full address"
                      size="small"
                      multiline
                      rows={2}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Document Section */}
                  {/* <Grid item xs={12} sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 2 }}>
                      Documents
                    </Typography>
                  </Grid>

                  
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Aadhar Card (Front)"
                      file={aadharFront}
                      onFileChange={(e) => handleFileChange(e, setAadharFront)}
                      onFileRemove={() => handleFileRemove(setAadharFront)}
                    />
                  </Grid>

                  
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Aadhar Card (Back)"
                      file={aadharBack}
                      onFileChange={(e) => handleFileChange(e, setAadharBack)}
                      onFileRemove={() => handleFileRemove(setAadharBack)}
                    />
                  </Grid>

                  
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Driving License (Front)"
                      file={licenseFront}
                      onFileChange={(e) => handleFileChange(e, setLicenseFront)}
                      onFileRemove={() => handleFileRemove(setLicenseFront)}
                    />
                  </Grid>

                  
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Driving License (Back)"
                      file={licenseBack}
                      onFileChange={(e) => handleFileChange(e, setLicenseBack)}
                      onFileRemove={() => handleFileRemove(setLicenseBack)}
                    />
                  </Grid> */}
                </Grid> 
              </Box>

              {/* Form buttons */}
              <Box display="flex" gap={2} mt={3}>
                <Button
                  variant="contained"
                  onClick={handleSaveDriver}
                  sx={{
                    bgcolor: "#4285F4",
                    color: "white",
                    "&:hover": { bgcolor: "#3367D6" },
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleCloseModal}
                  sx={{
                    borderColor: "#bdbdbd",
                    color: "#424242",
                    "&:hover": {
                      borderColor: "#9e9e9e",
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Slide>
    </Modal>
  );
}
